class logoList extends HTMLElement {
  constructor() {
    super();
    if (window.innerWidth <= 767) {
      this.initSlider();
    }
  }
  initSlider = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(this.initSlider, 100);
      return;
    }
    new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 4,
      spaceBetween: 10,
      autoplay: {
        delay: 2500,
      },
      loop: true
    })
  }
}
customElements.define('logo-list', logoList);